import moment from 'moment';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';

const momentDate = (dateTime) => moment(dateTime).format('DD.MM.YYYY');
const momentTime = (dateTime) => moment(dateTime).format('HH:mm');

const renderDuration = (duration) => {
  const min = duration / 60;

  if (min <= 1) {
    return `${duration} с`;
  }

  return `${Math.round(min)} м`;
};

export const callInfoAdapter = (data) => {
  const phoneNumber = data.callerId || data.callerIdNum;
  const master = data?.master?.shortName || '';
  const client = data?.client?.name || '';

  const result = {
    ...data,
    date: momentDate(data.createTime),
    time: momentTime(data.createTime),
    phone: formatPhoneNumber({
      phoneNumber,
      format: '(xxx) xxx-xx-xx',
      placeholder: 'x',
    }),
    master,
    client,
    masterData: data?.master,
    clientData: data?.client,
  };

  if (data.waitSecond) {
    result.waitSecond = renderDuration(data.waitSecond);
  }

  return result;
};
